export default {
	context: undefined,
	courseId: undefined,
	lesson: undefined,
	activity: undefined,
	lessonNavIsVisible: false,

	v2Lesson: null
};
